module.exports = __webpack_public_path__ + "img/logo_icon.e212508b.png";